import React from "react";
import ReactDOM from "react-dom";
import Home from "./apps/pages/Home";
import Providers from "./Providers";
import { GlobalStyles } from "./styled";

ReactDOM.render(
  <>
    <GlobalStyles />
    <Providers>
      <Home />
    </Providers>
  </>,
  document.getElementById("root")
);
